import { useQuery } from "react-query";

export const useSelfMapCheck = ({ tenantId, id }) => {
  const isCreateMode = !id;

  const createCheckQuery = useQuery(
    ["bpa-self-map-check", tenantId],
    () => Digit.OBPSService.BPASearch(tenantId),
    {
      enabled: !!tenantId && isCreateMode,
      refetchOnMount: "always",
      staleTime: 0,
      cacheTime: 0,
      select: (data) => {
        const selfMapCount =
          data?.BPA?.filter(app => app.planOn === "SELF_MAP")?.length || 0;

        return {
          selfMapExists: selfMapCount > 0
        };
      },
    }
   
  );

  return {
    isCreateMode,
    isLoading: createCheckQuery.isLoading,
    selfMapExists: createCheckQuery.data?.selfMapExists,
  };
};
